module.exports = __webpack_public_path__ + "fonts/FilsonProBold.d02b31e.otf";